import { useTimezones, useUserUpdateTimezone } from 'api/requests';
import { FormSubmit } from 'libs/form';
import { useTranslation } from 'libs/i18n';
import { useNotify } from 'libs/notify';
import { useUser } from 'libs/providers';

import { TimezoneFormType } from '../forms/timezoneForm';
import { getTimezoneLabel } from '../helpers/getTimezoneLabel';

export const useTimezoneSettings = () => {
  const notify = useNotify();
  const { t } = useTranslation();

  const { user, reUser } = useUser();
  const { timezones, loading } = useTimezones();
  const { loading: submitLoading, updateTimezone } = useUserUpdateTimezone();

  const settingTimezone = user?.settings.timezone;

  const userTimezoneName = Intl.DateTimeFormat('en').resolvedOptions().timeZone;
  const userTimezone = timezones?.find((tz) => tz.name === userTimezoneName);

  const initialValues: TimezoneFormType = {
    timezone: settingTimezone
      ? {
          value: settingTimezone.name,
          label: getTimezoneLabel(settingTimezone),
        }
      : timezones?.length && userTimezone
      ? {
          value: userTimezone.name,
          label: getTimezoneLabel(userTimezone),
        }
      : undefined,
    isAutomaticTimezone: !settingTimezone,
  };

  const onSubmit: FormSubmit<TimezoneFormType> = async (values) => {
    await updateTimezone(
      !values.isAutomaticTimezone
        ? values.timezone?.value || undefined
        : undefined
    );
    notify.info(t('common.successSave'));
    await reUser();
  };

  return {
    timezones,
    initialValues,
    loading: loading && !timezones,
    submitLoading,
    onSubmit,
  };
};
